import { Box, Typography } from '@mui/material';
import CompanySystemTitle from '../components/company-system-title/CompanySystemTitle';

const getWelcomeCompanyName = () => {
  if (typeof window === 'undefined') {
    return '華辰企業雲端ERP';
  }

  const company = (sessionStorage.getItem('company') || '').trim().toUpperCase();

  if (company === 'FM') {
    return '福蒙雲端ERP';
  }

  return '華辰企業雲端ERP';
};

export default function ProductsPage() {
  const welcomeCompanyName = getWelcomeCompanyName();

  return (
    <>
      <CompanySystemTitle />

      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',   // 靠左
          background: 'linear-gradient(135deg, #e3e9ff 0%, #f9faff 100%)',
          pl: '15vw', // 推到畫面1/2左右 (15vw~20vw看字長度調整)
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontWeight: 'bold',
            color: '#223177',
            letterSpacing: 3,
            textAlign: 'left',
            fontSize: { xs: '2.5rem', md: '4.5rem', lg: '5rem' }, // 行動版/桌面版字更大
            lineHeight: 1.1,
          }}
        >
          歡迎使用<br />
          {welcomeCompanyName}
        </Typography>
      </Box>
    </>
  );
}
